// ANCHOR React
import { useState } from 'react';

// ANCHOR Toast
import { toast } from 'react-hot-toast';

// ANCHOR Base
import { SIZE } from 'baseui/button';
import { ModalButton, ModalFooter } from 'baseui/modal';

// ANCHOR Models
import { useCreateFormQuestionFormSubmitPayload } from '@lyon/scoped-models/form/create/CreateFormQuestionForm';
import { useFormQuestionsMutate } from '@lyon/scoped-models/form/FormQuestionsData';

// ANCHOR Graph State
import { useAuthToken } from '@lyon/nodes/firebase/auth/auth-token-node';

// ANCHOR Hooks
import { useSentryExceptionHandler } from '@lyon/utils/hooks/useSentryExceptionHandler';
import { usePromise } from '@lyon/utils/hooks/usePromise';

// ANCHOR API
import { createFormQuestion } from '@lyon/utils/api/forms';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

export const LyonCreateFormQuestionSubmit = constant(() => {
  const token = useAuthToken();
  const catchException = useSentryExceptionHandler();
  const [
    name, type, position, isDisabled, formId, setSuccess,
  ] = useCreateFormQuestionFormSubmitPayload();
  const mutate = useFormQuestionsMutate();

  const mounted = usePromise([
    token, name, type, position, isDisabled, formId,
  ]);

  const [loading, setLoading] = useState(false);

  function onClick() {
    if (token && name && type) {
      setLoading(true);

      const request = (async () => {
        await mounted(createFormQuestion({
          token,
          name,
          type,
          formId,
          position,
        }));

        await mounted(mutate());
      })();

      toast.promise(request, {
        loading: 'Adding form question',
        success: 'Successfully added form question',
        error: 'Failed adding form question',
      }).then(() => {
        setSuccess(true);
        setLoading(false);
      }, (error) => {
        setLoading(false);
        catchException(error);
      });
    }
  }

  return (
    <ModalFooter>
      <ModalButton
        type="button"
        onClick={onClick}
        size={SIZE.default}
        disabled={isDisabled}
        isLoading={loading}
      >
        Create Question
      </ModalButton>
    </ModalFooter>
  );
});
